module.exports = __webpack_public_path__ + "img/visa.f381d165.svg";